export default {
  CategoryCode: "",
  CategoryName: "",
  Description: "",
  IsActive: true,
  UserModified: localStorage.getItem("UserName"),
};
